import React from 'react';

// Uses the real logo's alpha silhouette, rather than approximating it with a letter.
export const EngravedVEmblem = ({ id, x, y, width, height }) => <svg x={x} y={y} width={width} height={height} viewBox="0 0 188 236" overflow="visible" aria-hidden="true" focusable="false" data-testid={`blackjack-engraved-v-${id}`}>
  <defs>
    <mask id={`${id}-v-mask`} maskUnits="userSpaceOnUse" x="0" y="0" width="188" height="236" style={{ maskType: 'alpha' }}>
      <image href="/v-emblem-engraving-outline.png" width="188" height="236" preserveAspectRatio="xMidYMid meet" />
    </mask>
    <linearGradient id={`${id}-v-floor`} x1="0" y1="0" x2="150" y2="236" gradientUnits="userSpaceOnUse">
      <stop stopColor="#648996" /><stop offset=".43" stopColor="#adcbd1" /><stop offset="1" stopColor="#3d6275" />
    </linearGradient>
    <filter id={`${id}-v-cut`} x="-12%" y="-12%" width="124%" height="124%" colorInterpolationFilters="sRGB">
      <feOffset in="SourceAlpha" dx="-2" dy="-2.5" result="shadowOffset" />
      <feComposite in="shadowOffset" in2="SourceAlpha" operator="out" result="shadowEdge" />
      <feFlood floodColor="#020a12" floodOpacity=".9" result="shadowColor" />
      <feComposite in="shadowColor" in2="shadowEdge" operator="in" result="shadow" />
      <feOffset in="SourceAlpha" dx="2.2" dy="2.8" result="lightOffset" />
      <feComposite in="lightOffset" in2="SourceAlpha" operator="out" result="lightEdge" />
      <feFlood floodColor="#b4e2e6" floodOpacity=".9" result="lightColor" />
      <feComposite in="lightColor" in2="lightEdge" operator="in" result="bevel" />
      <feMerge><feMergeNode in="shadow" /><feMergeNode in="SourceGraphic" /><feMergeNode in="bevel" /></feMerge>
    </filter>
  </defs>
  <g filter={`url(#${id}-v-cut)`}><rect width="188" height="236" fill={`url(#${id}-v-floor)`} mask={`url(#${id}-v-mask)`} /></g>
</svg>;